import { configureStore } from '@reduxjs/toolkit';
import newslettersReducer from '@/store/slices/newslettersSlice';
import actionItemsReducer from '@/store/slices/actionItemsSlice';
import versionsReducer from '@/store/slices/versionsSlice';
import uiReducer from '@/store/slices/uiSlice';

export const store = configureStore({
  reducer: {
    newsletters: newslettersReducer,
    actionItems: actionItemsReducer,
    versions: versionsReducer,
    ui: uiReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
